// src/components/HowWeDoIt.jsx
import React from "react";
import "./HowWeDoIt.css";
import SignupIcon from "../../assets/HowWeDoItBox/Signup.png";
import ProfileIcon from "../../assets/HowWeDoItBox/Profile.png";
import ShareIcon from "../../assets/HowWeDoItBox/Share.png";

const steps = [
  {
    icon: SignupIcon,
    step: "STEP 1",
    title: "Sign Up And\nDescribe Your Topic",
  },
  {
    icon: ProfileIcon,
    step: "STEP 2",
    title: "Choose Your\nInspirational Creator\nAnd Genre",
  },
  {
    icon: ShareIcon,
    step: "STEP 3",
    title: "Create Your Post With\nBrandly And Share It\nDirectly On LinkedIn!",
  },
];

const HowWeDoIt = () => {
  return (
    <div className="how-we-section">
      <h2 className="how-we-heading">
        <span className="blue-text">How</span> We Do It
      </h2>

      <div className="how-we-card">
        {steps.map((step, index) => (
          <div className="how-we-box" key={index}>
            <div className="how-we-icon-wrapper">
              <img src={step.icon} alt={`Step ${index + 1}`} className="how-we-icon" />
            </div>
            <p className="how-we-step">{step.step}</p>
            <p className="how-we-title">{step.title}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default HowWeDoIt;
